import React from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';

import Brand from 'modules/partial/components/Brand';
import PageTitle from 'modules/common/components/PageTitle';
import PageLoader from 'modules/common/components/PageLoader';
import InformationCard from 'modules/merchant/order-management/all-orders/cards/InformationCard';
import OrderDetailCard from 'modules/merchant/order-management/all-orders/cards/OrderDetailCard';

import ActionButton from './ActionButton';
import DeliveryCard from '../card/DeliveryCard';
import OrderSummaryCard from '../card/OrderSummaryCard';
import {
  useConfirmOrder,
  useDeliveredOrder,
  useGetOrderDetails,
} from '../hooks';

function OrderDetails() {
  document.body.className = 'overflow-y-auto';

  const history = useHistory();
  const { order_number, otp } = useParams();
  const [isApiGetLoading, data] = useGetOrderDetails(order_number, {
    pin: otp,
  });

  const { system_status } = data;

  const [isApiConfirmLoading, confirm] = useConfirmOrder(order_number);
  const [isApiDeliveredLoading, delivered] = useDeliveredOrder(order_number);

  const handleOnUpdateStatus = () => {
    if (system_status === 'FOR_PICKUP')
      confirm(order_number, () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    if (system_status === 'IN_TRANSIT') {
      delivered(order_number, () => {
        history.push('/r/delivered_order');
      });
    }
  };

  if (isApiGetLoading && isEmpty(data)) {
    return (
      <div className="h-screen w-full">
        <PageLoader className="bg-transparent" />
      </div>
    );
  }

  return (
    <>
      <PageTitle title="PEP | Order Details" />
      <div className="h-full m-auto">
        <div className="mt-24 z-10">
          <div className="flex justify-center">
            <Brand className="h-8" />
          </div>
        </div>
        <div className="mt-10 mb-20">
          <div className="grid grid-cols-1 gap-4 mt-3">
            <DeliveryCard data={data} />
            <OrderDetailCard data={data} />
            <OrderSummaryCard data={data} />
            <div className="mb-28">
              <InformationCard data={data} />
            </div>
          </div>
        </div>
      </div>
      <ActionButton
        status={system_status}
        isLoading={isApiConfirmLoading || isApiDeliveredLoading}
        onUpdateStatus={handleOnUpdateStatus}
      />
    </>
  );
}
OrderDetails.defaultProps = {};

OrderDetails.propTypes = {};

export default OrderDetails;
